import { ajaxSuccess } from './helpers';

const BTN_NOTCH_SPINNER_ICON = `<i class="fa fa-circle-notch fa-spin m-auto text-pink"></i>`;

let _currentUserContent;
$(document).on('click', '.btn-user-name-edit', function(e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const _tpl = document.querySelector(`template#user-name-input-container`).content.cloneNode(true)

    $(this).tooltip('hide')

    const $parent = $(this).closest('.user-name')
    const $innerContent = $parent.find('.inner-content')

    $innerContent.html(_tpl)

    // _currentUserContent = $innerContent.html()
    // $innerContent.html(_tpl)
    // $innerContent.slideToggle(250)
    
    // requestAnimationFrame(() => $innerContent.css({ transform: 'translateX(-300px)' }))

    // setTimeout(() => {
    //     requestAnimationFrame(() => {
    //         $innerContent
    //         .html(_tpl)
    //         .css({
    //             transform: 'translateX(0)'
    //         })
    //     })
    // }, 350)
})

$(document).on('click', '.navbar-dropdown .dropdown-menu', function(e) {
    e.stopPropagation()
    e.stopImmediatePropagation()
})

// $(document).on('click', '.user-name .btn-user-name-submit', function(e) {
    // e.preventDefault();
    // const _userName = $(this).closest('.user-name').find('input[name="name"]').val()
    // if(!_userName) return;
    // _updateName(_userName)
// })

$(document).on('submit', '.user-name .inner-content form.form-update-name', function(e) {
    e.preventDefault();

    const $btn = this.querySelector('button.btn-user-name-submit')
    $btn.setAttribute('disabled', true)
    const _oldBtnContent = $btn.innerHTML;
    $btn.innerHTML = BTN_NOTCH_SPINNER_ICON;

    const _userName = Array.from(this.elements)
    .find(el => el.id == 'nav-user-name')
    .value

    axios({
        method: 'PATCH',
        url: this.action,
        data: {
            name: _userName
        },
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res);
        const { data: { user = null } = {} } = res.data
        if(user) {
            // document.querySelector('nav .user-name').innerHTML = res.data.data.user
            const $innerContent = $('nav .dropdown .user-container .user-name')
            $innerContent.html(user)

            // requestAnimationFrame(() => $innerContent.css({ transform: 'translateX(-300px)' }))
            // setTimeout(() => {
            //     requestAnimationFrame(() => {
            //         $innerContent
            //         .html(res.data.data.user)
            //         .css({
            //             transform: 'translateX(0)'
            //         })
            //     })
            // }, 350)
        } else {
            window.location.reload()
        }
    }, (err) => {
        $btn.innerHTML = _oldBtnContent
        $btn.removeAttribute('disabled')
    })
})

$(document).on('change', 'nav.navbar .navbar-nav .upload-avatar-form', function(e) {
    e.preventDefault()
    const $this = $(this)
    const $iconContainer = $this.find('.icon-container')
    const $input = $this.find('input[name="nav-user-avatar-input"]')

    const formData = new FormData();
    formData.append('avatar', $input.prop('files')[0])

    const _setupLoading = () => {
        $input.attr('disabled', true)
        $iconContainer.find('svg').fadeOut(125, function() {
            $iconContainer.find('.loading-icon').show()
        })
    }
    const _cancelLoading = () => {
        $input.attr('disabled', false)
        $iconContainer.find('.loading-icon').fadeOut(125, function() {
            $iconContainer.find('svg').show()
        })
    }

    _setupLoading()

    axios({
        method: this.method,
        url: this.action,
        data: formData,
        headers: {
            'Accept': 'application/json',
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        },
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res);
        const { data: { avatar = null } = {} } = res.data
        if(avatar) {
            const $userAvatarContainer = $('.outer-user-avatar-container[data-current-user-avatar-container]')
            if($userAvatarContainer.find('.user-avatar-image').length) $userAvatarContainer.find('.user-avatar-image').attr('src', avatar)
            else $userAvatarContainer.html(`<img src="${avatar}" alt="User Gravatar" class="img-fluid user-avatar-image w-100" />`)
        }
        _cancelLoading()
    }, (err) => _cancelLoading())
})